var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M10.083 5V1.497c0-.643.518-1.164 1.167-1.164h3.5c.644 0 1.167.522 1.167 1.164V5h7.582c1.29 0 2.334 1.044 2.334 2.336V21.33c0 1.29-1.046 2.336-2.334 2.336H2.5c-1.29 0-2.334-1.044-2.334-2.336V7.336C.167 6.046 1.213 5 2.5 5h7.582z",
    transform: "translate(-909 -481) translate(776 164) translate(133 317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.5 7.333v14h21v-14h-7.583v1.17c0 .643-.518 1.164-1.167 1.164h-3.5c-.644 0-1.167-.522-1.167-1.164v-1.17H2.5z",
    transform: "translate(-909 -481) translate(776 164) translate(133 317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M6 13.167c0-1.289 1.045-2.334 2.333-2.334 1.289 0 2.334 1.045 2.334 2.334 0 .724-.33 1.74-.849 2.491l1.492.747c.289.144.523.52.523.85v.578c0 .645-.526 1.167-1.171 1.167H6.005c-.647 0-1.172-.518-1.172-1.167v-.578c0-.325.23-.703.517-.847l1.5-.748c-.52-.751-.85-1.768-.85-2.493z",
    transform: "translate(-909 -481) translate(776 164) translate(133 317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.417 2.667L12.417 7.333 13.583 7.333 13.583 2.667z",
    transform: "translate(-909 -481) translate(776 164) translate(133 317)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M13 13.167c0-.645.523-1.167 1.17-1.167h5.827c.646 0 1.17.518 1.17 1.167 0 .644-.524 1.166-1.17 1.166H14.17c-.646 0-1.17-.518-1.17-1.166zM13 16.667c0-.645.518-1.167 1.166-1.167h3.5c.645 0 1.167.518 1.167 1.167 0 .644-.517 1.166-1.166 1.166h-3.5c-.645 0-1.167-.518-1.167-1.166z",
    transform: "translate(-909 -481) translate(776 164) translate(133 317)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsDone);
export default __webpack_public_path__ + "static/media/fs_done.fb7c07957cc79f403139675a07e69173.svg";
export { ForwardRef as ReactComponent };